import { useEffect } from "react";

import { BugIcon } from "@ala/icons/tech/solid";

import { Button } from "../button/button";

export const ErrorPage = ({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) => {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="h-svh w-full px-4 xs:px-6">
      <div className="mx-auto flex size-full max-w-[500px] flex-col items-center justify-center gap-8 text-center text-contrast-900">
        <BugIcon className="size-32" secondary="fill-contrast-200 text-white" primary="fill-red-600 text-white" />

        <h1 className="text-[32px] leading-tight font-normal uppercase">Something went wrong</h1>
        <div className="flex flex-col gap-2">
          <p className="text-contrast-400">Please try again later or refresh the page.</p>
          <p className="text-sm text-contrast-300 italic">
            Error: {error.message} {error.digest}
          </p>
        </div>
        <Button onClick={() => reset()}>Try again</Button>
      </div>
    </div>
  );
};
